import { render } from "./states.vue?vue&type=template&id=3ddffc65"
import script from "./states.vue?vue&type=script&lang=js"
export * from "./states.vue?vue&type=script&lang=js"

import "./states.vue?vue&type=style&index=0&id=3ddffc65&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/t3_d_M4E/0/hellmanh/rb-app-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__